<template>
    <div class="feature-slider-area section-space--pt_60" id="feature">
        <div class="feature-slider position-relative">
            <div class="feature-slider__container">
                <div class="feature-slider__wrapper">
                    <swiper :options="swiperOption">
                        <!-- <swiper-slide>
                            <div class="feature-slider__single-slide">
                                <div class="feature-slider__single-slide-wrapper">
                                    <div class="row align-items-center">
                                        <div class="col-md-6 wow move-up">
                                            <div class="image">
                                                <img src="../assets/img/features/aeroland-branding-image-10.png" class="img-fluid" alt="">
                                            </div>
                                        </div>
                                        <div class="col-md-6 wow move-up">
                                            <div class="content">
                                                <h4 class="title">Japan Office Rent Tracker</h4>
                                                <div class="text">
                                                    <p>Immersive Data for Major Markets</p>
                                                    <p>Track office rent rates in markets with interactive visualizations.</p>
                                                    <p>The Office Rent Tracker illustrates the office rent cycle for core locations that attract the highest 
                                                       rents and represent the principal concentration of major occupiers. </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide> -->

                         <swiper-slide>
                             <div class="feature-slider__single-slide">
                                <div class="feature-slider__single-slide-wrapper">
                                    <div class="row align-items-center">
                                        <div class="col-md-6 wow move-up">
                                            <div class="image">
                                                <img src="../assets/img_design/img/pc/report_img.jpg" class="img-fluid" alt="">
                                            </div>
                                        </div>
                                        <div class="col-md-6 wow move-up">
                                            <div class="content">
                                                <h5 class="title">{{lan.key31[cur_lan]}}</h5>
                                                <div class="text">
                                                    <ul class="ul-style margin-bottom-20">
                                                        <li class="margin-bottom-20">{{lan.key32[cur_lan]}}</li>
                                                        <li class="margin-bottom-20">{{lan.key33[cur_lan]}}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         </swiper-slide>

                         <!-- <swiper-slide>
                             <div class="feature-slider__single-slide">
                                <div class="feature-slider__single-slide-wrapper">
                                    <div class="row align-items-center">
                                        <div class="col-md-6 wow move-up">
                                            <div class="image">
                                                <img src="../assets/img/features/aeroland-branding-image-12.png" class="img-fluid" alt="">
                                            </div>
                                        </div>
                                        <div class="col-md-6 wow move-up">
                                            <div class="content">
                                                <h4 class="title">Market Data Tools</h4>
                                                <div class="text">
                                                    Make informed business decisions based on actionable insights from the most sophisticated research and thought leadership platform in commercial real estate.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         </swiper-slide>
                         <div class="swiper-pagination swiper-pagination--vertical swiper-pagination-1"  slot="pagination"></div> -->
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'featureTwo',
        data (){
            return {
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
                swiperOption: {
                    speed: 600,
                    loop: true,
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        768:{
                            clickable: false
                        }
                    }
                }
            }
        }
    }
</script>